import { OrgType } from '../../../apis/facades/types/crmOrgsApiFacade.types';

export enum EnvironmentTypes {
  Production = 'Production',
  Development = 'Development',
  Sandbox = 'Sandbox',
}

export function getEnvironmentType(org: {
  isSandbox: boolean;
  isMain?: boolean;
  orgType?: string;
}): string {
  if (org.orgType === OrgType.Salesforce) {
    if (org.isSandbox) return EnvironmentTypes.Sandbox;
    if (!org.isMain) return EnvironmentTypes.Development;
    return EnvironmentTypes.Production;
  }
  return '-';
}
